import {
  GOOGLE_API_KEY,
  GOOGLE_PLACE_ID,
} from "../../config/google"

export async function getBusinessDetails() {
  const response = await fetch(
    `https://places.googleapis.com/v1/places/${GOOGLE_PLACE_ID}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Goog-Api-Key": GOOGLE_API_KEY,
        "X-Goog-FieldMask":
          "displayName,rating,userRatingCount,reviews",
      },
    }
  );

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return await response.json();
}